export const PERMISSIONS = {
  association: {
    about: {
      view: 'association.about.view',
      update: 'association.about.update',
    },
    instructions: {
      view: 'association.instructions.view',
      create: 'association.instructions.create',
      update: 'association.instructions.update',
      delete: 'association.instructions.delete',
      publish: 'association.instructions.publish',
      unpublish: 'association.instructions.unpublish',
    },
    rulesAndRegulationsPage: {
      view: 'association.rules-and-regulations.view',
      create: 'association.rules-and-regulations.create',
      update: 'association.rules-and-regulations.update',
      delete: 'association.rules-and-regulations.delete',
      publish: 'association.rules-and-regulations.publish',
      unpublish: 'association.rules-and-regulations.unpublish',
    },
    boardMembers: {
      view: 'association.board-members.view',
      create: 'association.board-members.create',
      update: 'association.board-members.update',
      delete: 'association.board-members.delete',
    },
    weaponGroups: {
      view: 'association.weapon-groups.view',
      update: 'association.weapon-groups.update',
    },
  },
  members: {
    view: 'members.view',
    create: 'members.create',
    update: 'members.update',
    delete: 'members.delete',
    shootingClearances: {
      grant: 'members.shooting-clearances.grant',
      revoke: 'members.shooting-clearances.revoke',
    },
  },
  roles: {
    view: 'roles.view',
    create: 'roles.create',
    update: 'roles.update',
    delete: 'roles.delete',
    addMember: 'roles.members.add',
    removeMember: 'roles.members.remove',
  },
  newsItems: {
    view: 'news-items.view',
    create: 'news-items.create',
    update: 'news-items.update',
    delete: 'news-items.delete',
    publish: 'news-items.publish',
    unpublish: 'news-items.unpublish',
  },
  users: {
    invite: 'users.invite',
    revoke: 'users.revoke',
  },
  competitions: {
    view: 'competitions.view',
    create: 'competitions.create',
    update: 'competitions.update',
    delete: 'competitions.delete',
    review: 'competitions.review',
    disciplines: {
      view: 'competitions.disciplines.view',
      create: 'competitions.disciplines.create',
      update: 'competitions.disciplines.update',
      delete: 'competitions.disciplines.delete',
    },
  },
};
